import { render, staticRenderFns } from "./Profiles.vue?vue&type=template&id=8a213db8&scoped=true&"
import script from "./Profiles.vue?vue&type=script&lang=js&"
export * from "./Profiles.vue?vue&type=script&lang=js&"
import style0 from "./Profiles.vue?vue&type=style&index=0&id=8a213db8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a213db8",
  null
  
)

export default component.exports